// Types
import Vue from 'vue';
import consola from 'consola';
const PageWithSections = Vue.extend({
  provide() {
    return {
      setComponentMeta: (component, key, value) => {
        if (!this.pageData.components) return;
        const index = this.pageData.components.indexOf(component);
        if (index < 0) {
          consola.error('Component not found');
          return;
        }
        const c = this.pageData.components[index];
        if (!c.linkMeta) {
          c.linkMeta = {}; // just to make typescript happy
          this.$set(c, 'linkMeta', {});
        }
        this.$set(c.linkMeta, key, value);
      },
      pageData: this.pageData
    };
  },
  data() {
    return {
      pageData: {}
    };
  },
  beforeRouteLeave(from, to, next) {
    if (this.$isInEditMode) {
      const weGood = confirm(this.$t('core.warning.unsavedChanges'));
      weGood && next();
    } else {
      next();
    }
  },
  methods: {
    async saveChanges({
      success,
      fail
    }) {
      var _this$pageData$compon, _this$$application$la;
      // todo: might need some more logic, data refreshing etc.

      const formattedSectionsData = ((_this$pageData$compon = this.pageData.components) === null || _this$pageData$compon === void 0 ? void 0 : _this$pageData$compon.map((section, index) => ({
        ...section,
        order: index
      }))) || [];
      const payload = {
        slugMain: this.pageData.slugMain,
        components: formattedSectionsData,
        language_code: (_this$$application$la = this.$application.language) === null || _this$$application$la === void 0 ? void 0 : _this$$application$la.code,
        onlyExisting: true
      };
      const res = await this.$api.cms.link.postTranslation(payload);
      await this.$components.saveElementsConfig();

      // TODO: This needs to be typed
      if (res.errored) {
        // @ts-ignore
        fail(res.data);
      } else {
        // @ts-ignore
        success(res.data);
      }
    }
  }
});
export default PageWithSections;